import { Suspense, useEffect } from "react"
import { QueryClient, QueryClientProvider, QueryErrorResetBoundary } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import type { ErrorBoundaryPropsWithRender } from "react-error-boundary"
import { ErrorBoundary } from "react-error-boundary"
import { ConfigProvider, Spin } from "antd"
import zhCN from "antd/es/locale/zh_CN"
import AuthProvider from "./auth/AuthProvider"
import "./app.scss"
import ErrorContent from "./components/ErrorBoundary/components/ErrorContent"
import Pages from "@/routes"

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        // suspense: true,
      },
    },
  })

  // 接收到iframe的数据直接跳转
  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      const origin = event.origin
      if (
        origin.includes("//static.newayz.com") &&
        (event.data === "go" || event.data?.payload === "go")
      ) {
        // 跳转到选址页面
        const hashParams = /^#\/(\d+)\/(\d+)\/(\w+)$/.exec(window.location.hash)
        if (hashParams) {
          const [, brandId, cityId] = hashParams
          window.location.hash = `/${brandId}/${cityId}/selection`
        }
      }
    }

    window.addEventListener("message", handleMessage)
    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [])

  const fallbackRender: ErrorBoundaryPropsWithRender["fallbackRender"] = ({
    error,
    resetErrorBoundary,
  }) => {
    return <ErrorContent message={error.message} resetErrorBoundary={resetErrorBoundary} />
  }

  return (
    <QueryClientProvider client={queryClient}>
      <QueryErrorResetBoundary>
        {({ reset }) => (
          <ErrorBoundary fallbackRender={fallbackRender} onReset={reset}>
            <Suspense fallback={<Spin />}>
              <ConfigProvider locale={zhCN}>
                <AuthProvider>
                  <Pages />
                </AuthProvider>
              </ConfigProvider>
            </Suspense>
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}

export default App
